import { format, isAfter, isBefore } from 'date-fns'

import { EMPTY_STRING } from '../../../constants/common'
import { TIME_INPUT_FORMAT } from '../../../constants/date'
import { createTime, matchTimeInput } from '../../../utils/date'

/**
 * @param {Date | null} time
 *
 * @returns {string}
 */
export function formatTimeInputValue(time) {
  return time == null ? EMPTY_STRING : format(time, TIME_INPUT_FORMAT)
}

/**
 * @param {string} string
 * @param {{date: Date?, maxValue: Date?, minValue: Date?, timeZone: string?}} options
 *
 * @returns {Date | null}
 */
export function parseTimeInputValue(string, { maxValue, minValue }) {
  const match = matchTimeInput(string)

  if (match) {
    const value = createTime(match)

    if (minValue == null || maxValue == null || !isBefore(minValue, maxValue)) {
      const isBeforeMin = minValue != null && isBefore(value, minValue)
      const isAfterMax = maxValue != null && isAfter(value, maxValue)

      return isBeforeMin && isAfterMax
        ? null
        : isBeforeMin
          ? minValue
          : isAfterMax
            ? maxValue
            : value
    }
  }

  return null
}
